<app-container [sidebar]="true">
  <app-header-meta-action [title]="'Dokumente'">
    @if (isAccountant | async) {
      <button appTailwindButton (click)="fileInput.click()">Dokument hinzufügen</button>
    }
  </app-header-meta-action>

  <app-sidebar-navigation>
    @if (!(isAccountant | async)) {
      <app-sidebar-navigation-entry [routerLink]="'inbox'">Inbox </app-sidebar-navigation-entry>
    }
    <app-sidebar-navigation-entry [routerLink]="'accounting'"
      >Zur Bearbeitung (Buchhaltung)
    </app-sidebar-navigation-entry>
    @for (archiveFolder of archiveFolder | async; track archiveFolder.id) {
      <app-sidebar-navigation-entry [routerLink]="'archive/' + archiveFolder.id">
        <div class="flex justify-between">
          <span class="truncate">{{ archiveFolder.name }}</span
          ><span class="font-normal text-xs">{{
            !(isAccountant | async)
              ? archiveFolder.documentCount
              : archiveFolder.sharedDocumentCount
          }}</span>
        </div>
      </app-sidebar-navigation-entry>
    }
    <app-sidebar-navigation-entry [routerLink]="'search'">Suche </app-sidebar-navigation-entry>
    <a href="/settings/document" class="flex text-xs text-fg-faint items-center justify-end"
      >Einstellungen</a
    >
  </app-sidebar-navigation>

  <router-outlet></router-outlet>
</app-container>

<input hidden type="file" #fileInput (change)="uploadFile($event)" />
